var map = {
	"./auth/auth.module": [
		"./src/app/auth/auth.module.ts",
		"auth-auth-module"
	],
	"./dates/dates.module": [
		"./src/app/dates/dates.module.ts",
		"dates-dates-module~documents-documents-module~familia-familia-module~persona-persona-module",
		"common",
		"dates-dates-module"
	],
	"./documents/documents.module": [
		"./src/app/documents/documents.module.ts",
		"dates-dates-module~documents-documents-module~familia-familia-module~persona-persona-module",
		"common",
		"documents-documents-module"
	],
	"./familia/familia.module": [
		"./src/app/familia/familia.module.ts",
		"dates-dates-module~documents-documents-module~familia-familia-module~persona-persona-module",
		"common",
		"familia-familia-module"
	],
	"./inventario/inventario.module": [
		"./src/app/inventario/inventario.module.ts",
		"common",
		"inventario-inventario-module"
	],
	"./persona/persona.module": [
		"./src/app/persona/persona.module.ts",
		"dates-dates-module~documents-documents-module~familia-familia-module~persona-persona-module",
		"common",
		"persona-persona-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;